import { RouteItem } from '@eastcoal/router/types/route'

import {
  ROLE_CREATE_PAGE_PATH,
  ROLE_DETAIL_PAGE_PATH,
  ROLE_EDIT_PAGE_PATH,
  ROLE_LIST_PAGE_PATH
} from './constants/path'
import { ROLE_PAGE_UUID, ROLE_ACTION_UUID } from './constants/uuid'

export const roleRoute: RouteItem = {
  title: '角色管理',
  hideChildrenInMenu: true,
  children: [
    {
      title: '角色列表',
      path: ROLE_LIST_PAGE_PATH,
      uuid: ROLE_PAGE_UUID,
      Component: () => import('./List')
    },
    {
      title: '管理角色',
      uuid: ROLE_ACTION_UUID,
      children: [
        {
          title: '新增角色',
          path: ROLE_CREATE_PAGE_PATH,
          Component: () => import('./Create')
        },
        {
          title: '编辑角色',
          path: ROLE_EDIT_PAGE_PATH,
          Component: () => import('./Edit')
        },
        {
          title: '查看角色',
          path: ROLE_DETAIL_PAGE_PATH,
          Component: () => import('./Detail')
        }
      ]
    }
  ]
}
